class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.reAtttachListeners();
    this.updateCouponDaysRemaining();
    this.updateCouponButton();
    this.removeDiscountUpdate();
   }
  
  reAtttachListeners() {
    const couponOpenButton = this.querySelector(".more-offers");
    if (couponOpenButton) couponOpenButton.addEventListener("click", this.openOffers.bind(this));
    const couponCloseButton = this.querySelector(".close-offers");
    if (couponCloseButton) couponCloseButton.addEventListener("click", this.closeOffers.bind(this));
  }

  
  
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      this.reAtttachListeners();
      this.updateCouponDaysRemaining();
      this.updateCouponButton();
      this.removeDiscountUpdate();
       
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  openOffers() {
    const discountSection = this.querySelector(".discount-section");
    if (discountSection) discountSection.style.display = "block";
  }
  
  closeOffers() {
    const discountSection = this.querySelector(".discount-section");
    if (discountSection) discountSection.style.display = "none";
  }

 

  
  updateCouponButton() {
    document.querySelectorAll('.apply-button').forEach(button => {
  button.addEventListener('click', async function () {
    const promoCard = this.closest('.promo-card');
    const promoCode = promoCard.querySelector('.promo-code').textContent.replace('PROMO CODE: ', '').trim();
    const discountMessage = promoCard.querySelector('.discount-message') || document.createElement('div');
    discountMessage.className = 'discount-message';
    promoCard.appendChild(discountMessage);

    if (!promoCode) {
      discountMessage.textContent = 'No promo code found.';
      discountMessage.classList.add('error');
      return;
    }

    try {
       const initialCart = await fetch('/cart.js').then(res => res.json());
      const initialDiscount = initialCart.total_discount;

       if (initialDiscount > 0) {
        discountMessage.textContent = 'Applying..';
        await fetch('/checkout?discount='); // Clear current discount
      }

       await fetch(`/checkout?discount=${promoCode}`);

       const updatedCart = await fetch('/cart.js').then(res => res.json());
      const updatedDiscount = updatedCart.total_discount;

       if (updatedDiscount > 0) {
        discountMessage.textContent = 'Applied';
        discountMessage.classList.add('success');
        discountMessage.classList.remove('error');
      } else {
        discountMessage.textContent = 'Not applied. Please check your coupon code.';
        discountMessage.classList.add('error');
        discountMessage.classList.remove('success');
      }
       fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['#CartDrawer-Form','.cart-drawer__footer'];
          selectors.forEach(selector => {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
             var discountSections = document.getElementsByClassName("discount-section");
            for (var i = 0; i < discountSections.length; i++) {
              discountSections[i].style.display = "none";
            }
          });
        })
        .catch(e => console.error('Error refreshing cart drawer:', e));
    } catch (error) {
      console.error('Error applying discount:', error);
      discountMessage.textContent = 'An error occurred. Please try again.';
      discountMessage.classList.add('error');
    }
  });
    });
  }

removeDiscountUpdate() {
  document.addEventListener('click', async function (event) {
    const removeLink = event.target.closest('.remove-discount-link');
    if (removeLink) {
       const button_text_dis = document.querySelector('.remove-cupon-button-wrapper .remove-discount-link')
      const button_loading_dis = document.querySelector('.remove-cupon-button-wrapper .loading__spinner')
      button_text_dis.classList.add('opacity-0');
      button_loading_dis.classList.remove('hidden')
  
      try {
        await fetch('/discount/clear');
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['#CartDrawer-Form', '.cart-drawer__footer'];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
          })
          .catch((e) => {
            console.error('Error updating cart drawer:', e);
          });
      } catch (error) {
        console.error('Error clearing discount:', error);
      } finally {
        button_text_dis.classList.remove('opacity-0');
      button_loading_dis.classList.add('hidden')
      }
    }
  });
}


  
updateCouponDaysRemaining() {
  const daysRemainingElements = document.querySelectorAll(".days-remaining");

  daysRemainingElements.forEach((element) => {
    const endDate = element.getAttribute("data-end-date");

    if (endDate) {
      const updateRemainingDays = () => {
        const today = new Date();
        const targetDate = new Date(endDate);
        const timeDifference = targetDate - today;
        const remainingDays = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

        if (remainingDays > 0) {
          element.textContent = `${remainingDays} days remaining`;
        } else {
          element.style.display = "none"; // Hide the coupon when expired
        }
      };

      // Update immediately on page load
      updateRemainingDays();

      // Update daily at midnight
      const now = new Date();
      const timeUntilMidnight =
        new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0) -
        now;

      setTimeout(() => {
        updateRemainingDays();
        setInterval(updateRemainingDays, 24 * 60 * 60 * 1000); // Update every 24 hours
      }, timeUntilMidnight);
    } else {
      element.style.display = "none"; // Hide if no end date is provided
    }
  });
  }
  
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

function CartDrawerUpdate(selector, section_id, drawer, item_count){
    var t = selector;
    i = document.createElement("div");
    i.innerHTML = section_id;
    t.classList.remove('is-empty');
    t.replaceChild(i.querySelector("#CartDrawer"), t.querySelector("#CartDrawer"));
    let cartLink = document.querySelector('#cart-icon-bubble');
    if(drawer == false && item_count == 0){
      cartLink.querySelector('.cart-count-bubble span').innerText = 0;
       t.classList.add('is-empty');
    }else{
      var count = t.querySelector("cart-drawer-items").getAttribute('data-cart-count');
      $("#cart-icon-bubble").append(` <div class="cart-count-bubble">
             
                <span aria-hidden="true">${count}</span>
              
              <span class="visually-hidden">${count}</span>
            </div>`);
      cartLink.dispatchEvent(new Event('click'));
    }
}

customElements.define('cart-drawer-items', CartDrawerItems);


